import Unsubscribe from "../components/Unsubscribe";
import { Grid } from "@mui/material";
import translations from "../translations/english.json";
import Wrapper from "../components/Wrapper";

const UnsubscribeEn = () => {
  return (
    <Wrapper lang="en">
      <Grid container alignItems="center" justifyContent="center">
        <Unsubscribe translations={translations.unsubscribe} lang="en" />
      </Grid>
    </Wrapper>
  );
};

export default UnsubscribeEn;
